/**
 * @generated SignedSource<<6cbf1eef2dd0308d6ce74992febb58f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeSlotWizardStepContainerNode$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepNode" | "AddPlayersStepNode" | "PreviousBookingsStep_TimeSlot" | "TimeSlotBookingDetailsStepNode">;
  readonly " $fragmentType": "TimeSlotWizardStepContainerNode";
};
export type TimeSlotWizardStepContainerNode$key = {
  readonly " $data"?: TimeSlotWizardStepContainerNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSlotWizardStepContainerNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "memberId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSlotWizardStepContainerNode",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "memberId",
          "variableName": "memberId"
        },
        {
          "kind": "Variable",
          "name": "membershipTypeId",
          "variableName": "membershipTypeId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "TimeSlotBookingDetailsStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayersStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayersPrivateStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreviousBookingsStep_TimeSlot"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "7d6a4158202caabcedbdcb467ee429a2";

export default node;
